import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const CookiesUtil = {
  setCookie(name: string, value: string, options?: any): void {
    /** exam
    var expires = new Date();
    expires.setTime(expires.getTime() + 1 * 24 * 60 * 60 * 1000);

    setCookie('쿠키명', '저장할 문자', {
      path: '/',
      secure: '/',
      expires: expires;
    });
    */
    const cookieOptions = {
      path: '/', // 기본 경로 설정
      ...options, // 사용자 입력 옵션 (expires 등)
      sameSite: 'none', // 모든 도메인 허용 (Cross-site)
      secure: true, // HTTPS 연결에서만 전송 (None 설정 시 필수)
    };
    cookies.set(name, value, cookieOptions);
  },
  getCookie(name: string): string | null {
    /** exam
    getCookie('쿠키명');
    */
    return cookies.get(name);
  },
  removeCookie(name: string, options?: any): void {
    cookies.remove(name, {
      path: '/',
      ...options,
      sameSite: 'none',
      secure: true,
    });
  },
};
export default CookiesUtil;
